import * as React from 'react';
import { getColor } from '@panel/commons/core/themev3';
import { select } from '@panel/commons/core/themev2';

const CheckIcon = props => (
  <svg className='iconSVG' xmlns='http://www.w3.org/2000/svg' width={18} height={13} fill='none' {...props}>
    <path
      fill={props.disabled ? select('midNeutralGray') : getColor('primary')}
      d='M6.55 13 .85 7.3l1.425-1.425L6.55 10.15 15.725.975 17.15 2.4 6.55 13Z'
    />
  </svg>
);

export default CheckIcon;
